import { MessageCircle } from 'lucide-react';

export const WhatsAppButton = () => {
  const whatsappNumber = '+21622757639';
  const message = encodeURIComponent('Hello! I am interested in getting a website for my business.');
  
  return (
    <a
      href={`https://wa.me/${whatsappNumber.replace('+', '')}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 bg-[#25D366] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:scale-110 transition-transform duration-300 animate-pulse-subtle"
      aria-label="Contact via WhatsApp"
    >
      <MessageCircle className="w-6 h-6 sm:w-7 sm:h-7 fill-current" />
    </a>
  );
};
